import {SET_OFFLINE, SET_ONLINE} from 'new-constants/connectivity.constants';

export const setOnline = () => ({
	type: SET_ONLINE,
});

export const setOffline = () => ({
	type: SET_OFFLINE,
});
